/**
 * VenueSetupLayoutService
 * Service for VenueSetupLayout entity operations
 * Route: api/venuesetuplayouts
 * Controller: VenueSetupLayoutsController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * VenueSetupLayoutService
 * Handles venue setup layout CRUD operations and custom endpoints
 * Maps to /api/venuesetuplayouts endpoint
 */
export class VenueSetupLayoutService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VenueSetupLayoutService.DEFAULT_SERVICE_PATH,
            basePath: VenueSetupLayoutService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== CUSTOM METHODS ====================
    /**
     * Get all setup layouts for a venue booking
     * GET /api/venuesetuplayouts/booking/{venueBookingId}
     * @param venueBookingId - Venue booking ID
     * @returns Array of venue setup layouts
     */
    async getByBooking(venueBookingId) {
        const response = await this.getByBookingRaw(venueBookingId);
        return response.data ?? [];
    }
    getByBookingRaw(venueBookingId) {
        const url = this.buildUrl('booking/' + venueBookingId);
        return this.http.get(url);
    }
    /**
     * Get all reusable setup layouts for a venue
     * GET /api/venuesetuplayouts/GetByVenue/{venueId}
     * @param venueId - Venue ID
     * @returns Array of venue setup layouts
     */
    async getByVenue(venueId) {
        const response = await this.getByVenueRaw(venueId);
        return response.data ?? [];
    }
    getByVenueRaw(venueId) {
        const url = this.buildUrl('GetByVenue/' + venueId);
        return this.http.get(url);
    }
}
VenueSetupLayoutService.DEFAULT_SERVICE_PATH = 'meetings';
VenueSetupLayoutService.BASE_PATH = 'api/venuesetuplayouts';
//# sourceMappingURL=VenueSetupLayoutService.js.map